import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_BASE_URL } from '../../../environments/environment';
import { InstantDebitTaskDetails } from './instantDebitTaskDetails';

@Injectable({
  providedIn: 'root',
})
export class InstantDebitService {
  constructor(private http: HttpClient) {}

  private taskId: string;

  public getDetails(taskId: string): Observable<InstantDebitTaskDetails> {
    if (!this.taskId && taskId) {
      this.taskId = taskId;
    }

    // The id of the task is provided as a request header which is set by the TaskIdInterceptor.
    return this.http.get<InstantDebitTaskDetails>(
      `${SERVER_BASE_URL}/instantdebit/getAccount`
    );
  }

  public getAccounts(taskId: string) {
    let params = new HttpParams();

    params = params.append('taskId', taskId);

    return this.http.get<BankAccountListResponse>(
      `${SERVER_BASE_URL}/instantdebit/getAccountList/`,
      { params: params }
    );
  }

  public registerAccount(accountNumber: string, clearingNumber: string) {
    let params = new HttpParams();
    if (clearingNumber) {
      params = params.append('clearingNumber', clearingNumber);
    }
    if (accountNumber) {
      params = params.append('accountNumber', accountNumber);
    }

    return this.http.get<InstantDebitTaskDetails>(
      `${SERVER_BASE_URL}/instantdebit/accounts/register`,
      { params: params }
    );
  }
}

export class BankAccountListResponse {
  accounts: BankAccountInfo[];
  paymentRequestId: string;
  bankLogoUrl: string;
}

export class BankAccountInfo {
  id: string;
  accountName: string;
  balance: number;
  currencyCode: string;
  clearingNumber: string;
  accountNumber: string;
  bankName: string;
  bankLogoUrl: string;
  favored: boolean;
}
